import { Suspense } from 'react'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { ClerkContextProvider } from '@/context/clerk-context'
import { Toaster } from '@/components/ui/sonner'
import FeatureLoading from '@/components/feature-loading'
import { NavigationProgress } from '@/components/navigation-progress'
import GeneralError from '@/features/errors/general-error'
import NotFoundError from '@/features/errors/not-found-error'

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  component: () => {
    return (
      <ClerkContextProvider>
        <NavigationProgress />
        <Suspense fallback={<FeatureLoading />}>
          <Outlet />
        </Suspense>
        <Toaster duration={50000} />
        {import.meta.env.MODE === 'development' && (
          <>
            <ReactQueryDevtools buttonPosition='bottom-left' />
            <TanStackRouterDevtools position='bottom-right' />
          </>
        )}
      </ClerkContextProvider>
    )
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
